import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Card, CardContent, Paper, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField,
    Tooltip
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { formatData, formatDateForInput } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class AgendaEscalaFornecedorList extends Component {
    state = {
        searchFilter: JSON.parse(sessionStorage.getItem('agendaescalafornecedorSearchFilter')) || {
            dataservico: '' // ajustar para trazer por padrão a data atual
        },
        agendaescalasfornecedores: [],
        totalItems: 0,
        page: Number(sessionStorage.getItem('agendaescalafornecedorPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('agendaescalafornecedorRowsPerPage')) || 10
    };
    estilo = {
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30
    };


    constructor(props) {
        super(props);
    };

    /* Carregamento inicial */
    async componentDidMount() {
        const { searchFilter } = this.state;

        // se não houver filtro persistido, assume a data atual por padrão
        if (!searchFilter.dataservico) {
            searchFilter.dataservico = formatDateForInput(new Date());
            this.setState({ searchFilter }, this.loadAgendaEscalasFornecedor);
            return;
        }

        this.loadAgendaEscalasFornecedor();
    };

    /* Paginação */
    componentDidUpdate(prevState) {
        const { searchFilter, page, rowsPerPage } = this.state;

        // persiste filtros e paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            sessionStorage.setItem('agendaescalafornecedorSearchFilter', JSON.stringify(searchFilter));
        }
        if (prevState.page !== page) {
            sessionStorage.setItem('agendaescalafornecedorPage', page);
        }
        if (prevState.rowsPerPage !== rowsPerPage) {
            sessionStorage.setItem('agendaescalafornecedorRowsPerPage', rowsPerPage);
        }
    };

    /* Carrega agenda de escalas do fornecedor */
    loadAgendaEscalasFornecedor = async () => {
        const { page, rowsPerPage, searchFilter } = this.state;
        const { dataservico } = searchFilter;
        const idPartner = sessionStorage.getItem('idPartner');
        let params = `?page=${page + 1}&limit=${rowsPerPage}`;




        if (dataservico) {
            params += `&DATASERVICO=_like_${dataservico}`;
        }

        if (idPartner) {
            params += `&CODFORNECEDORTRANSP=${sessionStorage.getItem('idPartner')}`;
        }

        try {
            const response = await api.get('/agendaescalafornecedor' + params);
            this.setState({
                agendaescalasfornecedores: response.data.data || [],
                totalItems: parseInt(response.data.info && response.data.info.totalrecords, 10) || 0
            });
        } catch (error) {
            console.error('Erro ao carregar agenda de escalas do fornecedor:', error);
            this.setState({ agendaescalasfornecedores: [], totalItems: 0 });
        }
    };

    /* Muda página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => this.loadAgendaEscalasFornecedor());
    };

    /* Muda quantidade por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, () => this.loadAgendaEscalasFornecedor());
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisar filtros na tela */
    onChangeSearch = (event) => {
        const { checked, name, type, value } = event.target;
        const searchFilter = { ...this.state.searchFilter };

        if (type === 'checkbox') {
            searchFilter[name] = checked;
        } else {
            searchFilter[name] = value;
        } // acredito que deva mudar algo aqui

        this.setState({ searchFilter });
    };

    /* Formato para campos hora */
    formatTime = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    /* Limpa Filtros na tela */
    limpaFiltros = () => {
        const searchFilter = {
            dataservico: formatDateForInput(new Date())
        };

        this.setState({ searchFilter }, () => {
            this.loadAgendaEscalasFornecedor();
        });
    };

    render() {
        const {
            searchFilter,
            agendaescalasfornecedores,
            openAlert,
            messageAlert,
            totalItems,
            page,
            rowsPerPage
        } = this.state;

        const basePath = this.props.match.path.startsWith('/admpartner')
            ? '/admpartner'
            : '/partner';

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        padding: '12px 15px',
                        width: '100%'
                    }}
                >
                    <TextField
                        label="Data"
                        name="dataservico"
                        id="dataservico"
                        onChange={this.onChangeSearch}
                        type="date"
                        value={searchFilter.dataservico}
                        InputLabelProps={{
                            shrink: true,
                            required: false
                        }}
                        style={{
                            minWidth: 150,
                            flex: '0 1 150px'
                        }}
                    />

                    <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 5 }}>
                        <Tooltip
                            title="Procurar"
                            enterDelay={50}
                        >
                            <SearchIcon
                                onClick={() => this.loadAgendaEscalasFornecedor()}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                style={{
                                    fontSize: 24,
                                    color: '#0000ee',
                                    cursor: 'pointer',
                                    marginLeft: 15,
                                    marginRight: 6
                                }}
                            />
                        </Tooltip>

                        <Tooltip
                            title="Limpar"
                            enterDelay={50}
                        >
                            <BackspaceOutlinedIcon
                                onClick={() => this.limpaFiltros()}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                style={{
                                    fontSize: 24,
                                    color: '#0000ee',
                                    cursor: 'pointer',
                                    marginLeft: 6
                                }}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Nº Escala</TableCell>

                                            <TableCell align="center">Hora Serviço</TableCell>

                                            <TableCell align="center">Serviço</TableCell>

                                            <TableCell align="center">Data Escala</TableCell>

                                            <TableCell align="center">Total Pax</TableCell>

                                            <TableCell align="center">Visualizar</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {agendaescalasfornecedores.map(agendaescalafornecedor => (
                                            <TableRow
                                                hover
                                                key={agendaescalafornecedor.coditemescala}
                                            >
                                                <TableCell align="center">
                                                    {agendaescalafornecedor.coditemescala}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {this.formatTime(agendaescalafornecedor.horaservico)}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {agendaescalafornecedor.descservico}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {formatData(agendaescalafornecedor.dataservico)}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {agendaescalafornecedor.totalpax}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Tooltip
                                                        title="Visualizar"
                                                        enterDelay={50}
                                                    >
                                                        <Link to={`${basePath}/agendaescalafornecedor/${agendaescalafornecedor.coditemescala}/view`}>
                                                            <VisibilityOutlinedIcon
                                                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#0000ee'
                                                                }}
                                                            />
                                                        </Link>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>

                <TablePagination
                    component="div"
                    count={totalItems}
                    page={page}
                    onPageChange={this.handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 50, 100, 150]}
                    labelRowsPerPage="Registros por página"
                />

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div>
        );
    }
}

export default AgendaEscalaFornecedorList;